module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/menu_icon_social-66309.png";